import React from "react";
import { Box, Typography } from "@mui/material";
import { Navigation } from "lucide-react";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const ExpeditionHud = ({
  waypoints = [],
  activeWaypointIndex = 0,
  travelledDistance = 0,
  totalDistance = 0,
  distanceUnit = "km",
  showHud = true,
}) => {
  const t = useScrollytellTranslation();
  if (!showHud || !Array.isArray(waypoints) || waypoints.length < 2) {
    return null;
  }

  const totalStages = waypoints.length;
  const currentStageNum = Math.min(totalStages, Math.max(1, activeWaypointIndex + 1));
  const activeWaypoint = waypoints[activeWaypointIndex] || waypoints[0];
  const activeTitle = activeWaypoint?.title || `Stopp ${currentStageNum}`;
  const roundedDist = Math.round(travelledDistance);
  const roundedTotal = Math.round(totalDistance);

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: "absolute",
        top: 16,
        right: 16,
        zIndex: 5,
        backgroundColor: "rgba(15, 23, 42, 0.85)",
        backdropFilter: "blur(12px)",
        color: "#FFFFFF",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        borderRadius: "12px",
        padding: "12px 18px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.37)",
        minWidth: 200,
        pointerEvents: "auto",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        <Navigation size={16} color="#38BDF8" style={{ transform: "rotate(45deg)" }} />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: "#38BDF8",
            fontSize: "11px",
          }}
        >
          {t("expeditionHud.stageProgress", `Stoppested ${currentStageNum} av ${totalStages}`)}
        </Typography>
      </Box>

      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          color: "#FFFFFF",
          fontSize: "16px",
          lineHeight: 1.2,
          mb: 0.5,
        }}
      >
        {activeTitle}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "#CBD5E1",
          fontSize: "13px",
          fontWeight: 500,
        }}
      >
        <span>{roundedDist}</span> / {roundedTotal} <span>{distanceUnit}</span>
      </Typography>

      {/* Semantic sr-only itinerary list (WCAG 1.1.1) */}
      <ol
        aria-label={t("expeditionHud.itineraryLabel", "Reiserute og etapper")}
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        {waypoints.map((wp, idx) => (
          <li key={wp.id || idx}>
            Stopp {idx + 1}: {wp.title || `Stoppested ${idx + 1}`}
          </li>
        ))}
      </ol>
    </Box>
  );
};
